export function isValidOptionText(text) {
  if (text === null || text === undefined) {
    return false;
  }
  const trimmed = String(text).trim().toLowerCase();
  return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined';
}
